import { Component } from '@angular/core';
import { NavigationService } from 'app/utils/navigation/navigation.service';

@Component({
    moduleId: module.id,
    selector: 'eir-risk-carrier-change',
    templateUrl: './eir-risk-carrier-change.component.html',
    styleUrls: ['./eir-risk-carrier-change.component.less'],
})
export class EirRiskCarrierChangeComponent {
    activeTab = 'questions';

    constructor(public navigationService: NavigationService) {}

    setTab(tabName: string) {
        this.activeTab = tabName;
    }
}
